/** @format */

import {Modal, ModalHeader, ModalFooter, Toast} from '@sttark/design-system';
import {useSavedOrdersContext} from './saved_orders_context_provider';
import {useSave} from 'frontier/components/form/use_save';
import {Input, Button} from '@sttark/design-system';
import React, {useEffect, useState} from 'react';
import {useForm} from 'frontier-form';

export const NameColumn = props => {
    const {order} = props;

    const ctx = useSavedOrdersContext();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isToastOpen, setIsToastOpen] = useState(false);

    const {save, isSaving, error} = useSave('/orders/quote-update-customer-label/' + order.id);
    const {setFormData, formData} = useForm({customer_label: ''});

    const handleSubmit = async () => {
        try {
            await save(formData);
            ctx.handleRenameQuote(formData.customer_label, order.id);
            setIsToastOpen(true);
        } catch (err) {
            console.error(err);
        }
        setIsModalOpen(false);
    };

    useEffect(() => {
        setFormData({customer_label: order.customer_label});
    }, [order.customer_label]);

    return (
        <>
            <Toast
                onClose={() => setIsToastOpen(false)}
                autoHideDuration={4000}
                isOpen={isToastOpen}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">Quote renamed successfully</p>
            </Toast>
            <Modal onClose={() => setIsModalOpen(false)} isOpen={isModalOpen} bodyHeightAuto>
                <ModalHeader onClose={() => setIsModalOpen(false)}>Rename Quote</ModalHeader>
                <div>
                    <Input
                        onChange={value => setFormData({customer_label: value})}
                        placeholder={'Enter quote name'}
                        value={formData.customer_label}
                        name="customerLabel"
                        className=""
                        type="text"
                    />
                </div>

                <ModalFooter>
                    <div className="d-flex align-items-center justify-content-end gap-4">
                        <Button
                            onClick={() => setIsModalOpen(false)}
                            label="Cancel"
                            secondary
                            small
                        />
                        <Button
                            label={isSaving ? 'Saving' : 'Save'}
                            onClick={handleSubmit}
                            disabled={isSaving}
                            primary
                            small
                        />
                    </div>
                </ModalFooter>
            </Modal>
            <div className="saved-orders-list-table-active-00fb__column--type d-flex align-items-center justify-content-start">
                <p className="m-0 p-0">
                    {order.customer_label ? order.customer_label : `Saved-From-Cart-${order.index}`}
                </p>
                <button className="p-2 m-0" onClick={() => setIsModalOpen(true)}>
                    <i className="fa fa-pencil" />
                </button>
            </div>
        </>
    );
};
